<template>
  <div class="app-header">
    <div class="header-left">
      <el-icon
        class="toggle-sidebar"
        @click="toggleSidebar"
      >
        <Fold v-if="!sidebarCollapsed" /><Expand v-else />
      </el-icon>
      
      <!-- 系统切换器（both模式下显示） -->
      <div v-if="systemMode === 'both'" class="system-switcher">
        <el-segmented v-model="activeSystem" :options="systemOptions" @change="handleSystemSwitch" />
      </div>
      
      <div class="breadcrumb" v-if="showHeaderBreadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">
            首页
          </el-breadcrumb-item>
          <el-breadcrumb-item>
            {{ route.meta.title }}
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="header-right">
      <NotificationPopover />
      
      <el-dropdown trigger="click">
        <div class="user-profile">
          <img
            :src="userAvatar"
            alt="用户头像"
            class="avatar"
          >
          <span class="username">{{ userName }}</span>
          <el-icon><ArrowDown /></el-icon>
        </div>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item @click="navigateToProfile">
              <el-icon><UserFilled /></el-icon>
              <span>个人设置</span>
            </el-dropdown-item>
            <el-dropdown-item
              divided
              @click="handleLogout"
            >
              <el-icon><SwitchButton /></el-icon>
              <span>退出登录</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, inject, provide } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { Fold, Expand, UserFilled, Setting, SwitchButton, ArrowDown } from '@element-plus/icons-vue'
import NotificationPopover from '@/components/common/NotificationPopover.vue'

// 模拟数据
const userName = ref('管理员')
const userAvatar = ref('https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png')

// 路由相关
const route = useRoute()
const router = useRouter()

// 系统模式配置
const systemMode = ref(process.env.VUE_APP_SYSTEM || 'both')
const activeSystem = ref(route.path?.startsWith('/agent') ? 'agent' : 'original')

// 系统选项
const systemOptions = [
  { label: '原型系统', value: 'original' },
  { label: '代理商系统', value: 'agent' }
]

// 侧边栏状态，可能从父组件或状态管理中获取
const sidebarCollapsed = ref(false)

// 面包屑显示状态
const showHeaderBreadcrumb = ref(true)

// 提供一个方法给其他组件控制面包屑显示
const updateHeaderBreadcrumbVisibility = (visible) => {
  showHeaderBreadcrumb.value = visible
}

// 使用provide共享状态和方法
const updateSidebarCollapsed = inject('updateSidebarCollapsed', null)
provide('updateHeaderBreadcrumbVisibility', updateHeaderBreadcrumbVisibility)

// 处理系统切换
const handleSystemSwitch = (value) => {
  activeSystem.value = value
  // 切换到对应系统的首页
  if (value === 'agent') {
    router.push('/agent/daily-office')
  } else {
    router.push('/')
  }
}

// 切换侧边栏
const toggleSidebar = () => {
  sidebarCollapsed.value = !sidebarCollapsed.value
  
  // 通过provide/inject方式通知其他组件
  if (updateSidebarCollapsed) {
    updateSidebarCollapsed(sidebarCollapsed.value)
  }
}

// 处理登出
const handleLogout = () => {
  // 实际项目中应该调用登出接口
  router.push('/login')
}

// 跳转到个人设置页面
const navigateToProfile = () => {
  router.push('/user/profile')
}
</script>

<style scoped>
.app-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
}

.header-left, .header-right {
  display: flex;
  align-items: center;
}

.toggle-sidebar {
  font-size: 20px;
  cursor: pointer;
  margin-right: 20px;
  color: var(--text-secondary);
}

.system-switcher {
  margin: 0 20px;
}

.breadcrumb {
  font-size: 14px;
}

.user-profile {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.avatar {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  margin-right: 8px;
}

.username {
  font-size: 14px;
  margin-right: 5px;
}
</style> 